// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.mjs";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as MediaApiModel$PorterinFeature from "../../../media/domain/api-models/MediaApiModel.mjs";

function faqs_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var question = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "question"), null));
  if (question.TAG === /* Ok */0) {
    var answer = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "answer"), null));
    if (answer.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                question: question._0,
                answer: answer._0
              }
            };
    }
    var e = answer._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".answer" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = question._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".question" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function faqs_section_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var sub_text = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "sub_text"), null));
    if (sub_text.TAG === /* Ok */0) {
      var faqs = Decco.arrayFromJson(faqs_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "faqs"), null));
      if (faqs.TAG === /* Ok */0) {
        var toggle_icon = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "toggle_icon"), null));
        if (toggle_icon.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    title: title._0,
                    sub_text: sub_text._0,
                    faqs: faqs._0,
                    toggle_icon: toggle_icon._0
                  }
                };
        }
        var e = toggle_icon._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".toggle_icon" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = faqs._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".faqs" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = sub_text._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sub_text" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function meta_json_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var description = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
    if (description.TAG === /* Ok */0) {
      var faq_schema = Decco.optionFromJson((function (v) {
              return {
                      TAG: /* Ok */0,
                      _0: v
                    };
            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "faq_schema"), null));
      if (faq_schema.TAG === /* Ok */0) {
        var review_schema = Decco.optionFromJson((function (v) {
                return {
                        TAG: /* Ok */0,
                        _0: v
                      };
              }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "review_schema"), null));
        if (review_schema.TAG === /* Ok */0) {
          var local_business_schema = Decco.optionFromJson((function (v) {
                  return {
                          TAG: /* Ok */0,
                          _0: v
                        };
                }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "local_business_schema"), null));
          if (local_business_schema.TAG === /* Ok */0) {
            var image = Decco.optionFromJson(MediaApiModel$PorterinFeature.image_single_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
            if (image.TAG === /* Ok */0) {
              var is_no_index = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_no_index"), null));
              if (is_no_index.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          title: title._0,
                          description: description._0,
                          faq_schema: faq_schema._0,
                          review_schema: review_schema._0,
                          local_business_schema: local_business_schema._0,
                          image: image._0,
                          is_no_index: is_no_index._0
                        }
                      };
              }
              var e = is_no_index._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".is_no_index" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = image._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".image" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = local_business_schema._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".local_business_schema" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = review_schema._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".review_schema" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = faq_schema._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".faq_schema" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = description._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".description" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function city_image_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var city_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "city_name"), null));
  if (city_name.TAG === /* Ok */0) {
    var image = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
    if (image.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                city_name: city_name._0,
                image: image._0
              }
            };
    }
    var e = image._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".image" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = city_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".city_name" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function services_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
  if (text.TAG === /* Ok */0) {
    var service_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "service_type"), null));
    if (service_type.TAG === /* Ok */0) {
      var icon = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "icon"), null));
      if (icon.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  text: text._0,
                  service_type: service_type._0,
                  icon: icon._0
                }
              };
      }
      var e = icon._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".icon" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = service_type._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".service_type" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".text" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function cities_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var image = city_image_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
  if (image.TAG === /* Ok */0) {
    var services = Decco.arrayFromJson(services_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "services"), null));
    if (services.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                image: image._0,
                services: services._0
              }
            };
    }
    var e = services._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".services" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = image._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".image" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function all_cities_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var all_cities = Decco.arrayFromJson(cities_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "all_cities"), null));
  if (all_cities.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              all_cities: all_cities._0
            }
          };
  }
  var e = all_cities._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".all_cities" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function testimonial_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var customer_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "customer_name"), null));
  if (customer_name.TAG === /* Ok */0) {
    var rating = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "rating"), null));
    if (rating.TAG === /* Ok */0) {
      var porter_service = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "porter_service"), null));
      if (porter_service.TAG === /* Ok */0) {
        var testimonial_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "testimonial_text"), null));
        if (testimonial_text.TAG === /* Ok */0) {
          var city = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "city"), null));
          if (city.TAG === /* Ok */0) {
            var profile_pic = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "profile_pic"), null));
            if (profile_pic.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        customer_name: customer_name._0,
                        rating: rating._0,
                        porter_service: porter_service._0,
                        testimonial_text: testimonial_text._0,
                        city: city._0,
                        profile_pic: profile_pic._0
                      }
                    };
            }
            var e = profile_pic._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".profile_pic" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = city._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".city" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = testimonial_text._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".testimonial_text" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = porter_service._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".porter_service" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = rating._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".rating" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = customer_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".customer_name" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function customer_testimonials_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var testimonials = Decco.arrayFromJson(testimonial_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "testimonials"), null));
    if (testimonials.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                title: title._0,
                testimonials: testimonials._0
              }
            };
    }
    var e = testimonials._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".testimonials" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function testimonials_section_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var testimonials_section = Decco.optionFromJson(customer_testimonials_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "testimonials_section"), null));
  if (testimonials_section.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              testimonials_section: testimonials_section._0
            }
          };
  }
  var e = testimonials_section._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".testimonials_section" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function know_more_cta_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var label = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
  if (label.TAG === /* Ok */0) {
    var href = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "href"), null));
    if (href.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                label: label._0,
                href: href._0
              }
            };
    }
    var e = href._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".href" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = label._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".label" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function get_in_touch_cta_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var label = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
  if (label.TAG === /* Ok */0) {
    var link = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "link"), null));
    if (link.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                label: label._0,
                link: link._0
              }
            };
    }
    var e = link._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".link" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = label._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".label" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function short_link_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
  if (text.TAG === /* Ok */0) {
    var href = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "href"), null));
    if (href.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                text: text._0,
                href: href._0
              }
            };
    }
    var e = href._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".href" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".text" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function text_subtext_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
  if (text.TAG === /* Ok */0) {
    var sub_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sub_text"), null));
    if (sub_text.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                text: text._0,
                sub_text: sub_text._0
              }
            };
    }
    var e = sub_text._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sub_text" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".text" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function title_subtext_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var sub_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sub_text"), null));
    if (sub_text.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                title: title._0,
                sub_text: sub_text._0
              }
            };
    }
    var e = sub_text._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sub_text" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function image_title_desc_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var desc = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "desc"), null));
    if (desc.TAG === /* Ok */0) {
      var icon = MediaApiModel$PorterinFeature.image_src_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "icon"), null));
      if (icon.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  title: title._0,
                  desc: desc._0,
                  icon: icon._0
                }
              };
      }
      var e = icon._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".icon" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = desc._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".desc" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function image_title_desc_container_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var cards = Decco.arrayFromJson(image_title_desc_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "cards"), null));
    if (cards.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                title: title._0,
                cards: cards._0
              }
            };
    }
    var e = cards._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".cards" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function link_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var href = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "href"), null));
  if (href.TAG === /* Ok */0) {
    var label = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
    if (label.TAG === /* Ok */0) {
      var target = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "target"), null));
      if (target.TAG === /* Ok */0) {
        var isExternal = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isExternal"), null));
        if (isExternal.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    href: href._0,
                    label: label._0,
                    target: target._0,
                    isExternal: isExternal._0
                  }
                };
        }
        var e = isExternal._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".isExternal" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = target._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".target" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = label._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".label" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = href._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".href" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function image_desc_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var image = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
  if (image.TAG === /* Ok */0) {
    var description = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
    if (description.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                image: image._0,
                description: description._0
              }
            };
    }
    var e = description._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".description" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = image._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".image" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function hero_section_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var sub_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sub_text"), null));
    if (sub_text.TAG === /* Ok */0) {
      var know_more_cta = know_more_cta_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "know_more_cta"), null));
      if (know_more_cta.TAG === /* Ok */0) {
        var banner_img = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "banner_img"), null));
        if (banner_img.TAG === /* Ok */0) {
          var banner_img_mobile = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "banner_img_mobile"), null));
          if (banner_img_mobile.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      title: title._0,
                      sub_text: sub_text._0,
                      know_more_cta: know_more_cta._0,
                      banner_img: banner_img._0,
                      banner_img_mobile: banner_img_mobile._0
                    }
                  };
          }
          var e = banner_img_mobile._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".banner_img_mobile" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = banner_img._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".banner_img" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = know_more_cta._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".know_more_cta" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = sub_text._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sub_text" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function download_app_desktop_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var sub_title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sub_title"), null));
    if (sub_title.TAG === /* Ok */0) {
      var qr_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "qr_text"), null));
      if (qr_text.TAG === /* Ok */0) {
        var qr = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "qr"), null));
        if (qr.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    title: title._0,
                    sub_title: sub_title._0,
                    qr_text: qr_text._0,
                    qr: qr._0
                  }
                };
        }
        var e = qr._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".qr" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = qr_text._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".qr_text" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = sub_title._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sub_title" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function download_app_mobile_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var sub_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sub_text"), null));
    if (sub_text.TAG === /* Ok */0) {
      var button_label = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "button_label"), null));
      if (button_label.TAG === /* Ok */0) {
        var button_href = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "button_href"), null));
        if (button_href.TAG === /* Ok */0) {
          var app_icon = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "app_icon"), null));
          if (app_icon.TAG === /* Ok */0) {
            var app_store_image = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "app_store_image"), null));
            if (app_store_image.TAG === /* Ok */0) {
              var google_play_store_image = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "google_play_store_image"), null));
              if (google_play_store_image.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          title: title._0,
                          sub_text: sub_text._0,
                          button_label: button_label._0,
                          button_href: button_href._0,
                          app_icon: app_icon._0,
                          app_store_image: app_store_image._0,
                          google_play_store_image: google_play_store_image._0
                        }
                      };
              }
              var e = google_play_store_image._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".google_play_store_image" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = app_store_image._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".app_store_image" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = app_icon._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".app_icon" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = button_href._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".button_href" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = button_label._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".button_label" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = sub_text._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sub_text" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function service_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
  if (text.TAG === /* Ok */0) {
    var sub_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sub_text"), null));
    if (sub_text.TAG === /* Ok */0) {
      var cta = know_more_cta_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cta"), null));
      if (cta.TAG === /* Ok */0) {
        var image = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
        if (image.TAG === /* Ok */0) {
          var service_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "service_type"), null));
          if (service_type.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      text: text._0,
                      sub_text: sub_text._0,
                      cta: cta._0,
                      image: image._0,
                      service_type: service_type._0
                    }
                  };
          }
          var e = service_type._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".service_type" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = image._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".image" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = cta._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".cta" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = sub_text._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sub_text" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".text" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function city_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var city_id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "city_id"), null));
  if (city_id.TAG === /* Ok */0) {
    var city_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "city_name"), null));
    if (city_name.TAG === /* Ok */0) {
      var city_label = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "city_label"), null));
      if (city_label.TAG === /* Ok */0) {
        var city_link = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "city_link"), null));
        if (city_link.TAG === /* Ok */0) {
          var city_image = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "city_image"), null));
          if (city_image.TAG === /* Ok */0) {
            var category_services = Decco.arrayFromJson(service_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "category_services"), null));
            if (category_services.TAG === /* Ok */0) {
              var services = Decco.arrayFromJson(service_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "services"), null));
              if (services.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          city_id: city_id._0,
                          city_name: city_name._0,
                          city_label: city_label._0,
                          city_link: city_link._0,
                          city_image: city_image._0,
                          category_services: category_services._0,
                          services: services._0
                        }
                      };
              }
              var e = services._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".services" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = category_services._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".category_services" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = city_image._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".city_image" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = city_link._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".city_link" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = city_label._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".city_label" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = city_name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".city_name" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = city_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".city_id" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function city_attributes_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var attributes = city_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "attributes"), null));
  if (attributes.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              attributes: attributes._0
            }
          };
  }
  var e = attributes._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".attributes" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function cities_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = Decco.arrayFromJson(city_attributes_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

var HomeCities = {
  service_decode: service_decode,
  city_decode: city_decode,
  city_attributes_decode: city_attributes_decode,
  cities_decode: cities_decode$1
};

function city_image_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var city_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "city_name"), null));
  if (city_name.TAG === /* Ok */0) {
    var city_label = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "city_label"), null));
    if (city_label.TAG === /* Ok */0) {
      var image = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
      if (image.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  city_name: city_name._0,
                  city_label: city_label._0,
                  image: image._0
                }
              };
      }
      var e = image._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".image" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = city_label._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".city_label" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = city_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".city_name" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function services_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var service_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "service_name"), null));
  if (service_name.TAG === /* Ok */0) {
    var service_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "service_type"), null));
    if (service_type.TAG === /* Ok */0) {
      var service_icon = MediaApiModel$PorterinFeature.image_single_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "service_icon"), null));
      if (service_icon.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  service_name: service_name._0,
                  service_type: service_type._0,
                  service_icon: service_icon._0
                }
              };
      }
      var e = service_icon._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".service_icon" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = service_type._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".service_type" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = service_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".service_name" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function image_attribute_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var attributes = city_image_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict._0, "attributes"), null));
  if (attributes.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              attributes: attributes._0
            }
          };
  }
  var e = attributes._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".attributes" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function image_data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = image_attribute_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function service_attribute_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var attributes = services_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict._0, "attributes"), null));
  if (attributes.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              attributes: attributes._0
            }
          };
  }
  var e = attributes._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".attributes" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function service_data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = Decco.arrayFromJson(service_attribute_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function city_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var image = image_data_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
  if (image.TAG === /* Ok */0) {
    var services = service_data_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "services"), null));
    if (services.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                image: image._0,
                services: services._0
              }
            };
    }
    var e = services._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".services" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = image._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".image" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function city_attributes_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var attributes = city_decode$1(Belt_Option.getWithDefault(Js_dict.get(dict._0, "attributes"), null));
  if (attributes.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              attributes: attributes._0
            }
          };
  }
  var e = attributes._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".attributes" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function cities_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = Decco.arrayFromJson(city_attributes_decode$1, Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

var VehicleCities = {
  city_image_decode: city_image_decode$1,
  services_decode: services_decode$1,
  image_attribute_decode: image_attribute_decode,
  image_data_decode: image_data_decode,
  service_attribute_decode: service_attribute_decode,
  service_data_decode: service_data_decode,
  city_decode: city_decode$1,
  city_attributes_decode: city_attributes_decode$1,
  cities_decode: cities_decode$2
};

function form_field_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var label = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "label"), null));
  if (label.TAG === /* Ok */0) {
    var place_holder = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "place_holder"), null));
    if (place_holder.TAG === /* Ok */0) {
      var error_msg = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "error_msg"), null));
      if (error_msg.TAG === /* Ok */0) {
        var required = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "required"), null));
        if (required.TAG === /* Ok */0) {
          var icon = MediaApiModel$PorterinFeature.optional_image_src_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "icon"), null));
          if (icon.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      label: label._0,
                      place_holder: place_holder._0,
                      error_msg: error_msg._0,
                      required: required._0,
                      icon: icon._0
                    }
                  };
          }
          var e = icon._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".icon" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = required._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".required" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = error_msg._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".error_msg" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = place_holder._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".place_holder" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = label._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".label" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function hyperlink_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var sub_text = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "sub_text"), null));
    if (sub_text.TAG === /* Ok */0) {
      var link = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "link"), null));
      if (link.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  title: title._0,
                  sub_text: sub_text._0,
                  link: link._0
                }
              };
      }
      var e = link._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".link" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = sub_text._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sub_text" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function link_group_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
  if (text.TAG === /* Ok */0) {
    var links = Decco.arrayFromJson(hyperlink_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "links"), null));
    if (links.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                text: text._0,
                links: links._0
              }
            };
    }
    var e = links._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".links" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".text" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function internal_links_section_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
  if (text.TAG === /* Ok */0) {
    var internal_links = Decco.arrayFromJson(link_group_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "internal_links"), null));
    if (internal_links.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                text: text._0,
                internal_links: internal_links._0
              }
            };
    }
    var e = internal_links._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".internal_links" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".text" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function pointer_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
  if (text.TAG === /* Ok */0) {
    var sub_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sub_text"), null));
    if (sub_text.TAG === /* Ok */0) {
      var alt_tag = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "alt_tag"), null));
      if (alt_tag.TAG === /* Ok */0) {
        var image = MediaApiModel$PorterinFeature.image_attributes_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
        if (image.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    text: text._0,
                    sub_text: sub_text._0,
                    alt_tag: alt_tag._0,
                    image: image._0
                  }
                };
        }
        var e = image._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".image" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = alt_tag._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".alt_tag" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = sub_text._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sub_text" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".text" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function pointer_section_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var pointer = Decco.arrayFromJson(pointer_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "pointer"), null));
    if (pointer.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                title: title._0,
                pointer: pointer._0
              }
            };
    }
    var e = pointer._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".pointer" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function meta_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var title = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
  if (title.TAG === /* Ok */0) {
    var description = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
    if (description.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                title: title._0,
                description: description._0
              }
            };
    }
    var e = description._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".description" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = title._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".title" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function terms_and_conditions_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
  if (text.TAG === /* Ok */0) {
    var sub_text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "sub_text"), null));
    if (sub_text.TAG === /* Ok */0) {
      var link = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "link"), null));
      if (link.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  text: text._0,
                  sub_text: sub_text._0,
                  link: link._0
                }
              };
      }
      var e = link._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".link" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = sub_text._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".sub_text" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".text" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

export {
  faqs_decode ,
  faqs_section_decode ,
  meta_json_decode ,
  city_image_decode ,
  services_decode ,
  cities_decode ,
  all_cities_decode ,
  testimonial_decode ,
  customer_testimonials_decode ,
  testimonials_section_decode ,
  know_more_cta_decode ,
  get_in_touch_cta_decode ,
  short_link_decode ,
  text_subtext_decode ,
  title_subtext_decode ,
  image_title_desc_decode ,
  image_title_desc_container_decode ,
  link_decode ,
  image_desc_decode ,
  hero_section_decode ,
  download_app_desktop_decode ,
  download_app_mobile_decode ,
  HomeCities ,
  VehicleCities ,
  form_field_decode ,
  hyperlink_decode ,
  link_group_decode ,
  internal_links_section_decode ,
  pointer_decode ,
  pointer_section_decode ,
  meta_decode ,
  terms_and_conditions_decode ,
}
/* No side effect */
